import { Link, useLocation } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

const CATEGORY_NAMES: Record<string, string> = {
  'guanfang-rukou': '官方入口',
  'jingxiang-dizhi': '镜像地址',
  'beiyong-lianjie': '备用链接',
  'fangwen-jiaocheng': '访问教程',
  'changjian-wenti': '常见问题',
};

export default function Breadcrumb() {
  const location = useLocation();
  const pathSegments = location.pathname.split('/').filter(Boolean);

  const items: BreadcrumbItem[] = [{ label: '首页', href: '/' }];

  if (pathSegments[0] === 'category' && pathSegments[1]) {
    items.push({ label: CATEGORY_NAMES[pathSegments[1]] || pathSegments[1] });
  } else if (pathSegments[0] === 'article' && pathSegments[1]) {
    items.push({ label: '文章详情' });
  } else if (pathSegments[0] === 'about') {
    items.push({ label: '关于我们' });
  }

  if (items.length === 1) return null;

  return (
    <nav aria-label="面包屑导航" className="w-full bg-background-100 border-b border-background-200/70">
      <div className="max-w-6xl mx-auto px-4 md:px-6 py-3">
        <ol className="flex items-center flex-wrap gap-1 text-sm">
          {items.map((item, index) => (
            <li key={index} className="flex items-center">
              {index > 0 && (
                <span className="mx-2 text-foreground-400" aria-hidden="true">/</span>
              )}
              {index === items.length - 1 ? (
                <span className="text-foreground-600">{item.label}</span>
              ) : item.href ? (
                <Link to={item.href} className="text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap">
                  {item.label}
                </Link>
              ) : (
                <span className="text-foreground-600">{item.label}</span>
              )}
            </li>
          ))}
        </ol>
      </div>
    </nav>
  );
}